import { useMemo } from "react";

import useQuery from "../search/useQuery";
import QUERY_TAGS from "../search/queryTags";
import { mapWallet } from "../checkout/paymentsMappers";
import { fetchWalletBalance } from "./financeService";
import { VOLATILE_STALE_TIME } from "./financeCache";
import { TOP_UP_CURRENCY } from "./financeMoney";

const useWallet = ({ currencyCode = TOP_UP_CURRENCY, enabled = true } = {}) => {
  const code = String(currencyCode || TOP_UP_CURRENCY).toUpperCase();

  const query = useQuery({
    key: enabled && code ? `finance:wallet:${code}` : null,
    tag: QUERY_TAGS.PAYMENT_WALLET,
    staleTime: VOLATILE_STALE_TIME,
    enabled,
    fetcher: () => fetchWalletBalance(code),
  });

  const wallet = useMemo(() => mapWallet(query.currentData), [query.currentData]);

  return {
    wallet,
    currencyCode: code,
    balance: wallet?.balance || { value: 0, currency: code },
    isLoading: !wallet && !query.isError && query.enabled,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};

export default useWallet;
